import PropTypes from 'prop-types';
import Collection from "ol/Collection";
import VectorSourceImpl from './VectorSourceImpl';
import { ensureMap } from '../../../hocs/ensureMap';
import { VectorLayer } from '../VectorLayer';
var Component = VectorSourceImpl(VectorLayer);

/**
 * Component rendering features in a VectorLayer.
 *
 * See VectorLayer for properties configuring layer.
 *
 * @component
 */
export var VectorSource = function VectorSource(props) {
  return Component(props);
};
VectorSource.propTypes = {
  /**
   * Features to be rendered.
   */
  features: PropTypes.oneOfType([PropTypes.instanceOf(Collection), PropTypes.array])
};
export default ensureMap(VectorSource);